<div class="list-count me-3">
  <ng-container *ngIf="showSelectedCount; else countTemplate">
    {{ selectedLength }}/
    {{ selectedLength === 1
      ? (T.common.count_selected.one | translate: { count: count } | lowercase )
      : (T.common.count_selected.many | translate: { count: count } | lowercase) }}
  </ng-container>

  <ng-template #countTemplate>
    {{ count === 1
      ? (T.common.count_results.one | translate: { count: count } | lowercase)
      : (T.common.count_results.many | translate: { count: count }) | lowercase }}
  </ng-template>
</div>
